import React, { useState, useEffect } from 'react';
import { Container, Table, Badge, Button, Card, Spinner } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../api/api';
import AppHeader from '../Common/AppHeader';
import AppFooter from '../Common/AppFooter';

const AssessmentHistory = () => {
  const { slug, projectId } = useParams();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/tenant/${slug}/projects/${projectId}/assessment-history`)
      .then(res => {
        setHistory(res.data);
        setLoading(false);
      });
  }, [projectId, slug]);

  if (loading) return <Spinner animation="border" className="d-block mx-auto mt-5" aria-hidden="true" />;

  return (
<div className="bg-light min-vh-100 d-flex flex-column">
    <Container className="py-4">
    <div className="mb-3 d-flex justify-content-end">
      <Button 
        variant="success" 
        size="sm" 
        onClick={() => navigate(`/tenant/${slug}/projects`)}
      >
        <i className="bi bi-kanban me-2"></i> View All Projects
      </Button>
  </div>
      <h3 className="fw-bold mb-4">Generation History</h3>
      <Badge bg="light" text="dark" className="border px-3 py-2 mb-3">
      Project ID: {projectId}
    </Badge>
      <Card className="border-0 shadow-sm">
        <Table hover responsive className="mb-0 align-middle">
          <thead className="table-light small text-uppercase">
            <tr>
              <th>Blueprint Name</th>
              <th>Date & Time of Generation</th>
              <th>Question Volume</th>
              <th>Review Status</th>
              <th scope="col" className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {history.map((batch, index) => (
              <tr key={index}>
                {/* ✅ Show the Blueprint Name (e.g., "Mid-Term Set A") */}
                <td className="fw-bold text-primary">
                  {batch.blueprint_name || `Blueprint #${batch.blueprint_id}`}
                </td>
                <td>{new Date(batch.created_at).toLocaleString()}</td>
                <td><Badge bg="secondary">{batch.total_questions} Items</Badge></td>
                <td>
                  <Badge bg={batch.status === 'Fully Approved' ? 'success' : 'warning'}>
                    {batch.status}
                  </Badge>
                </td>
                <td className="text-end">
                  <Button 
                    variant="primary" size="sm"
                    
                    onClick={() => navigate(`/tenant/${slug}/projects/${projectId}/assessment-bank?timestamp=${batch.id}`)}
                  >
                    View Batch Details
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </Container>
<AppFooter />
</div>
  );
};

export default AssessmentHistory;

